import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NotifierService } from 'angular-notifier';
import { ajaxCall } from 'src/app/core/services/ajax-call.service';

@Component({
  selector: 'app-rename-vendor-file',
  templateUrl: './rename-vendor-file.component.html',
  styleUrls: []
})
export class RenameVendorFileComponent implements OnInit {
  @ViewChild(NgForm) fileForm!: NgForm;
  @Input() uploadInfo: DataFileRenameInformation;

  submitAttempt: boolean = false;

  constructor(private ajax: ajaxCall,
    private modal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  dismiss(): void {
    this.modal.dismiss();
  }

  save(): void {
    this.submitAttempt = true;
    if (this.fileForm.invalid) {
      return;
    }
    this.ajax.MakeCall('/Vendor/RenameFile', this.uploadInfo).then(() => {
      this.modal.close();
    }, () => { });
  }

}

class DataFileRenameInformation {
  vendorId: string;
  vendorFileId: string;
  commonName: string;
}